import Modal from 'shared/components/Modal'
import { currencyFromSymbol } from 'shared/currency-utilities'
import { FormattedNumber } from 'i18n'
import CircleLoader from '@components/CircleLoader'

const LoadingFallback = ({ cancelReservationPending, cancelAmendPolicyReservationPending }) => (
    <div className="d-flex justify-content-center align-items-baseline">
        <p style={{ marginRight: '10px' }}>
            {cancelAmendPolicyReservationPending && <T>reservation.cancel.cancellation-fee.loading</T>}
            {cancelReservationPending && <T>reservation.cancel.loading</T>}
        </p>
        <CircleLoader size="small" />
    </div>
)

const ConfirmationModal = ({
    reservationId,
    confirm,
    closeModal,
    cancellationData: { refundAmount, cancellationFee, currencySymbol },
    cancelReservationPending,
    cancelAmendPolicyReservationPending,
}) => {
    const currency = currencyFromSymbol(currencySymbol)

    return (
        <Modal
            header={<T>reservation.cancel.confirm.question</T>}
            onClose={closeModal}
            ComponentLoadingFallback={() => (
                <LoadingFallback
                    cancelReservationPending={cancelReservationPending}
                    cancelAmendPolicyReservationPending={cancelAmendPolicyReservationPending}
                />
            )}
            loading={cancelReservationPending || cancelAmendPolicyReservationPending}
            buttons={[
                { label: <T>reservation.cancel.confirm.button.label</T>, onClick: confirm.bind(null, reservationId) },
                { label: <T>reservation.cancel.cancel.button.label</T>, onClick: closeModal },
            ]}>
            <>
                <div>
                    <T>reservation.cancel.refund-amount.label</T>{' '}
                    <FormattedNumber value={refundAmount || 0} style="currency" currency={currency} />
                </div>
                <div>
                    <T>reservation.cancel.cancellation-fee.label</T>{' '}
                    <FormattedNumber value={cancellationFee || 0} style="currency" currency={currency} />
                </div>
            </>
        </Modal>
    )
}

export default ConfirmationModal
